<template>
    <div>
        <common-table :url="url"
                      :table-columns="tableColumns"
                      :form-fields="formFields"
                      :operate="operate"
                      :permission="permission"
                      :searchs="searchs"
                      ref="table">
        </common-table>
    </div>
</template>

<script>
    import CommonTable from "@/components/CommonTable/CommonTable";
    export default {
        name: "UserDailyInvestment",
        components: {CommonTable},
        data(){
            return{
                searchs:[
                    {
                        name: 'agentId',
                        placeholder: '代理',
                        type: 'select',
                        selectUrl: '/agent/getAll',
                        selectData: [],
                    },
                    {
                        name: 'phone',
                        placeholder: '手机号',
                        type: 'input'
                    },
                    {
                        name: 'status',
                        placeholder: '状态',
                        type: 'select',
                        selectValue:[{
                            key: 0,
                            value: '未完成'
                        },{
                            key: 1,
                            value: '已完成'
                        }]
                    },
                    {
                        name: 'startTime',
                        placeholder: '开始时间',
                        type: 'dateTime'
                    },
                    {
                        name: 'endTime',
                        placeholder: '结束时间',
                        type: 'dateTime'
                    }
                ],
                permission:{
                    /*add: 'userInvestment:add',
                    update: 'userInvestment:update',
                    delete: 'userInvestment:delete',
                    deleteBatch: 'userInvestment:deleteBatch'*/
                },
                url: {
                    get: '/userDailyInvestment/listByCondition',
                    //add: '/withdrawal/add',
                    //update: '/withdrawal/update',
                    //delete: '/withdrawal/delete/',
                    //delete_batch: '/withdrawal/deleteBatch',
                },
                tableColumns: [{
                    field: 'id',
                    label: 'ID',
                    show: true,
                    detail: true,
                    width: '',
                }, {
                    field: 'agentId',
                    label: '代理',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                    show: {
                        type: 'select',
                    },
                    detail: false,
                    width: '',
                },{
                    field: 'phone',
                    label: '用户',
                    show: true,
                    detail: true,
                    width: '',
                },{
                    field: 'amount',
                    label: '购买金额',
                    show: true,
                    detail: true,
                    width: '',
                },{
                    field: 'status',
                    label: '状态',
                    show: {
                        type: 'tag',
                        tags: [{
                            key: 0,
                            value: '未完成',
                            type: 'info'
                        },{
                            key: 1,
                            value: '已完成',
                            type: 'success'
                        }]
                    },
                    width: '',
                },{
                    field: 'name',
                    label: '购买项目',
                    show: true,
                    detail: true,
                    width: '',
                },{
                    field: 'cycle',
                    label: '周期(天)',
                    show: true,
                    detail: true,
                    width: '',
                },{
                    field: 'ratio',
                    label: '日收益比例',
                    show: {
                        type: 'thousandthsRatio'
                    },
                    detail: true,
                    width: '',
                },{
                    field: 'createTime',
                    label: '订单时间',
                    show: true,
                    detail: true,
                    width: '',
                },{
                    field: 'startTime',
                    label: '购买日期',
                    detail: true,
                    width: '',
                },{
                    field: 'endTime',
                    label: '到期日期',
                    detail: true,
                    width: '',
                },{
                    field: 'completeTime',
                    label: '完成时间',
                    detail: true,
                    width: '',
                }],
                formFields: {model: []},
                operate: []
            }
        },
    }
</script>

<style scoped>

</style>
